export const Height = {
  Small: 'small',
  Medium: 'medium',
  Large: 'large',
} as const;

export type Height = typeof Height[keyof typeof Height];
